import qr from "query-string";
import { useQuery } from "@tanstack/react-query";
import { fetcher, Pagination, PaginationResponse } from "@/shared/core-configs";
import { API } from "@/config";
import type { Reposition } from "../types/Replenishment";

export const GET_REPOSITION_FETCH_KEY = "getRepositions";

export type InvoiceFilter = "with" | "without";

export type RepositionFilters = {
  storageId?: string;
  dateFrom?: string;
  dateTo?: string;
  invoice?: InvoiceFilter;
};

type GetReplenishmentParams = {
  zoneId?: string;
  showDisabled?: boolean;
  searchTerm?: string;
  sort?: string;
  order?: string;
  filters?: RepositionFilters;
} & Partial<Pagination>;
const getRepositions = async (
  zoneId?: string,
  page?: number,
  pageSize?: number,
  showDisabled = false,
  searchTerm?: string,
  sort?: string,
  order?: string,
  filters?: RepositionFilters,
) => {
  const params = qr.stringify({
    zoneId,
    pageSize,
    page,
    showDisabled,
    searchTerm,
    sort,
    order,
    ...filters,
  });
  const response = await fetcher.get(`${API.GESLUB}/repositions?${params}`);
  return response.data;
};

export const useGetRepositions = ({
  zoneId,
  page,
  pageSize,
  sort,
  order,
  showDisabled,
  searchTerm,
  filters,
}: GetReplenishmentParams = {}) => {
  const { data, error, isLoading, isFetching, refetch } = useQuery<
    PaginationResponse<Reposition>
  >({
    queryKey: [
      GET_REPOSITION_FETCH_KEY,
      zoneId,
      page,
      pageSize,
      sort,
      order,
      showDisabled,
      searchTerm,
      filters,
    ],
    queryFn: () =>
      getRepositions(
        zoneId,
        page,
        pageSize,
        showDisabled,
        searchTerm,
        sort,
        order,
        filters,
      ),
    placeholderData: (prev) => prev,
  });

  const isPending = isLoading || isFetching;

  return {
    data: data?.data || [],
    pagination: data?.pagination,
    error,
    isPending,
    refetch,
  };
};
